<script setup lang="ts">
import {NamaNavigateToNextEmit} from "@/utils/common/NamaVueWidget.ts";
import {BlockProps} from "@/utils/presenters/interfaces.ts";
import InputWidgetsGroup from "@/components/EditView/editScreens/InputWidgetsGroup.vue";
import MainFileGroup from "@/components/EditView/editScreens/MainFileGroup.vue";
import EditScreenGroup = namaTypes.EditScreenGroup;

const props = defineProps<BlockProps>();
let block = props.block as EditScreenGroup;

defineEmits<NamaNavigateToNextEmit>()
</script>

<template>
  <template v-if="showMainFile">
    <MainFileGroup :block="block" :blockIndex="blockIndex" :presenter="presenter" :pageIndex="pageIndex" :collapsed="collapsed"
                   @navigateToNext="(args)=>$emit('navigateToNext', args)"/>
  </template>
  <template v-else>
    <InputWidgetsGroup :block="block" :blockIndex="blockIndex" :presenter="presenter" :pageIndex="pageIndex" :collapsed="collapsed"
                       @navigateToNext="(args)=>$emit('navigateToNext', args)"/>
  </template>
</template>

<style scoped>

</style>
